module.exports = __webpack_public_path__ + "console/img/唯品会.e1909e19.jpg";